import React from "react";

import { TableCell, TableRow } from "@mui/material";

const EmptyTableResults = ({
  tableHeading,
  colSpan,
}: {
  tableHeading: string;
  colSpan?: number;
}) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <b>{`No results for ${tableHeading}`}</b>
      </TableCell>
    </TableRow>
  );
};

export default EmptyTableResults;
